import Check from "pages/_components/Check";
import { bool, func, instanceOf, shape, string } from "prop-types";
import React from "react";
import CustomData from "pages/_components/CustomData/CustomData";
import { SingleBill } from "./SingleBill";

export const BillItem = ({ bill, billToPay, setBillToPay, paymentType, isDesktop }) => {
    const hableCheck = () => (
        <div
            className="payment-new-confirm"
            role="button"
            tabIndex={0}
            onClick={(e) => {
                e.preventDefault();
                setBillToPay(bill);
            }}
            onKeyDown={(e) => {
                e.preventDefault();
                setBillToPay(bill);
            }}>
            <Check
                hideLabel
                key={`check-box-${bill.hash}`}
                id={bill.hash}
                name={bill.hash}
                checked={billToPay?.hash === bill.hash}
            />
        </div>
    );
    return (
        bill?.status !== "FORMAT_ERROR" && (
            <>
                {isDesktop ? (
                    <div className="d-flex justify-content-between">
                        {hableCheck()}
                        <SingleBill bill={bill} paymentType={paymentType} isRow />
                    </div>
                ) : (
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                        {hableCheck()}
                        <div>
                            {bill.details.map((detail) => (
                                <div key={`bill-${detail.label}`}>
                                    <CustomData titleText={detail.label} valueText={detail.value} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </>
        )
    );
};

BillItem.propTypes = {
    bill: shape({}).isRequired,
    setBillToPay: func.isRequired,
    billToPay: instanceOf(Array).isRequired,
    paymentType: string.isRequired,
    isDesktop: bool.isRequired,
};

export default BillItem;
